import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useFormik } from "formik";
import BankAccountVerifyValues from "../../../entities/BankAccountVerifyValues";
import CustomInput from "../../../components/CustomInput/CustomInput";
import NextStepButton from "../../../components/NextStepButton/NextStepButton";
import { useSelector } from "react-redux";
import {
  OtpVerifyRegisterWithBankAccount,
  verifyWithBankAccountUtil,
} from "../../../services/OtpVerifyRegisterWithBankAccount";
import CircleLoading from "../../../components/CircleLoading/CircleLoading";
import RenderInputError from "../../Login/RenderInputError/RenderInputError";
import "./BankAccountVerify.scss";

const BankAccountVerify = (props: {
  setActiveStep: (arg0: number) => void;
  activeStep: number;
  registerBankAccountTokenNum:string|null|undefined;
}) => {
  const { t } = useTranslation("common");
  const { userId } = useSelector((state: any) => state.UserReducer);
  const [loading, setLoading] = useState<boolean>(false);
  const [isVerifyError, setVerifyError] = useState<boolean>(false);
  const [isMaxServerRequestsError, setMaxServerRequestsError] = useState<boolean>(false);

  const validate = (values: BankAccountVerifyValues) => {
    const errors: any = {};

    if (!values.bankAccountNum) {
      errors.bankAccountNum = t("BankAccountVerify.nullBankAccount");
    } else if (
      !(values.bankAccountNum.length >= 4 && values.bankAccountNum.length <= 9)
    ) {
      errors.bankAccountNum = t("BankAccountVerify.bankAccountError");
    } else if (
      // check for every digit that is a number
      values.bankAccountNum
        .split("")
        .filter((digit: string) => parseInt(digit) >= 0 && parseInt(digit) <= 9)
        .length !== values.bankAccountNum.length
    ) {
      errors.bankAccountNum = t("BankAccountVerify.bankAccountError");
    } else if (
      // handle all zeros case
      values.bankAccountNum
        .split("")
        .filter((digit: string) => parseInt(digit) === 0).length ===
      values.bankAccountNum.length
    ) {
      errors.bankAccountNum = t("BankAccountVerify.bankAccountError");
    }

    return errors;
  };

  const formik = useFormik({
    initialValues: {
      bankAccountNum: "",
    },
    validate,
    onSubmit: async (values: BankAccountVerifyValues) => {
      setLoading(true);
      const token = await OtpVerifyRegisterWithBankAccount(
        userId,
        values.bankAccountNum,
        props.registerBankAccountTokenNum
      );
      if (verifyWithBankAccountUtil.isSuccess(token)) {
        sessionStorage.setItem("token", token);
        props.setActiveStep(props.activeStep + 1);
      } else if (verifyWithBankAccountUtil.isMaxServerRequestsError(token)) {
        setMaxServerRequestsError(true);
      } else {
        isMaxServerRequestsError && setMaxServerRequestsError(false);
        setVerifyError(true);
      }
      setLoading(false);
    },
  });

  return loading ? (
    <CircleLoading />
  ) : (
    <form onSubmit={formik.handleSubmit}>
      <div className="bank-verify-main-text">
        <span>{t("BankAccountVerify.mainText")}</span>
      </div>
      <CustomInput
        formik={formik}
        fullWidth={true}
        keyString="bankAccountNum"
        inputLabel={t("BankAccountVerify.bankAccountNumber")}
        tooltipLabel={t("BankAccountVerify.tooltipLabel")}
        withIcon={true}
        withTooltip={true}
        space={false}
      />
      <NextStepButton text={t('general.next')} onclick={()=>{}}/>
      {(isVerifyError || isMaxServerRequestsError) && (
        <div >
          <RenderInputError
            errorLabel={
              isMaxServerRequestsError
                ? t("BankAccountVerify.sendAgainError")
                : t("BankAccountVerify.bankAccountNumNotCorrect")
            }
            style={{bottom:0}}
          />
        </div>
      )}
    </form>
  );
};

export default BankAccountVerify;
